import React from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const MountainBikingClassification = () => {
  const { t } = useTranslation()

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>
        {t('POI_TYPE_CLASSIFICATION_TITLE')}
      </h2>
      <p>{t('POI_TYPE_MOUNTAIN_BIKING_PAGE_CLASSIFICATION_DESCRIPTION')}</p>

      <div className="mt-5">
        <Table bordered className="rdb-table">
          <tbody>
            <tr>
              <td
                className="text-center align-middle"
                rowSpan="4"
                style={{
                  fontWeight: 'bold',
                  color: 'white',
                  backgroundColor: '#a38639',
                  width: '30%',
                }}
              >
                {t('DISTANCE_LABEL')}
              </td>
              <td className="text-left">{t('LESS_THAN_11KM')}</td>
              <td className="text-center" style={{ width: '10%' }}>
                1pt
              </td>
            </tr>
            <tr>
              <td className="text-left">{t('FROM_11_TO_20KM')}</td>
              <td className="text-center">2pts</td>
            </tr>
            <tr>
              <td className="text-left">{t('FROM_21_TO_40KM')}</td>
              <td className="text-center">3pts</td>
            </tr>
            <tr>
              <td className="text-left">{t('MORE_THAN_40KM')}</td>
              <td className="text-center">4pts</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="mt-5">
        <Table bordered className="rdb-table">
          <tbody>
            <tr>
              <td
                className="text-center align-middle"
                rowSpan="4"
                style={{
                  fontWeight: 'bold',
                  color: 'white',
                  backgroundColor: '#a38639',
                  width: '30%',
                }}
              >
                {t('ELEVATION_GAIN')}
              </td>
              <td className="text-left">{t('LESS_THAN_100M')}</td>
              <td className="text-center" style={{ width: '10%' }}>
                1pt
              </td>
            </tr>
            <tr>
              <td className="text-left">{t('FROM_101_TO_250M')}</td>
              <td className="text-center">2pts</td>
            </tr>
            <tr>
              <td className="text-left">{t('FROM_251_TO_600M')}</td>
              <td className="text-center">3pts</td>
            </tr>
            <tr>
              <td className="text-left">{t('MORE_THAN_600M')}</td>
              <td className="text-center">4pts</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="mt-5">
        <Table bordered className="rdb-table">
          <tbody>
            <tr>
              <td
                className="text-center align-middle"
                rowSpan="3"
                style={{
                  fontWeight: 'bold',
                  color: 'white',
                  backgroundColor: '#a38639',
                  width: '30%',
                }}
              >
                {t('PATH_TYPE')}
              </td>
              <td className="text-left">{t('STABILIZED_PATH')}</td>
              <td className="text-center" style={{ width: '10%' }}>
                1pt
              </td>
            </tr>
            <tr>
              <td className="text-left">{t('DIRT_OR_GRASS_PATH')}</td>
              <td className="text-center">2pts</td>
            </tr>
            <tr>
              <td className="text-left">{t('NARROW_PATH')}</td>
              <td className="text-center">3pts</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="mt-5">
        <Table bordered className="rdb-table">
          <tbody>
            <tr>
              <td
                className="text-center align-middle"
                rowSpan="4"
                style={{
                  fontWeight: 'bold',
                  color: 'white',
                  backgroundColor: '#a38639',
                  width: '30%',
                }}
              >
                {t('TECHNIQUE')}
              </td>
              <td className="text-left">{t('NO_SPECIAL_TECHNIQUE')}</td>
              <td className="text-center" style={{ width: '10%' }}>
                1pt
              </td>
            </tr>
            <tr>
              <td className="text-left">{t('BASIC_MOUNTAIN_BIKING_SKILLS')}</td>
              <td className="text-center">2pts</td>
            </tr>
            <tr>
              <td className="text-left">
                {t('ADVANCED_MOUNTAIN_BIKING_SKILLS')}
              </td>
              <td className="text-center">3pts</td>
            </tr>
            <tr>
              <td className="text-left">
                {t('EXPERT_MOUNTAIN_BIKING_SKILLS')}
              </td>
              <td className="text-center">4pts</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="mt-5 text-center">
        <Table bordered className="rdb-table">
          <thead>
            <tr>
              <th>{t('TOTAL_POINTS')}</th>
              <th>{t('TRAIL_COLOR')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('FROM_4_TO_5_POINTS')}</td>
              <td>{t('GREEN')}</td>
            </tr>
            <tr>
              <td>{t('FROM_6_TO_8_POINTS')}</td>
              <td>{t('BLUE')}</td>
            </tr>
            <tr>
              <td>{t('FROM_9_TO_12_POINTS')}</td>
              <td>{t('RED')}</td>
            </tr>
            <tr>
              <td>{t('FROM_13_TO_15_POINTS')}</td>
              <td>{t('BLACK')}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default MountainBikingClassification
